/**
 * Pop 진입점 헬퍼 (단일 소스: config/pop.php + App\Pop\Support\PopSeo)
 *
 * 랜딩(SPA)에서 Pop 으로 나가는 링크와 소개(/pop)가 그리는 게임 목록 · 문구는 **서버가 정한 값**을 쓴다.
 * landing.blade.php 가 `window.JadEye.pop` 으로 주입한다(POP_ENABLED=false 면 null).
 *
 * 🚨 컴포넌트에 게임을 손으로 적지 않는다 — 게임이 늘면 서버가 채우고 화면이 저절로 따라온다(lib/ink.ts 와 같은 규칙).
 */

export interface PopEntry {
    /** 소개 — '/pop'. 사람이 보는 진입점(앱바 · 카드 · 푸터)은 전부 여기로 간다. */
    landing: string;

    /** 한 줄 소개 — 「짬 날 때 톡 하고 노는 곳」. 푸터 · 카드가 같은 말을 쓴다. */
    tagline: string;

    /** 소개 머리의 문장들. */
    subtitle: string[];

    /** 「Pop의 약속」. */
    promises: PopPoint[];

    /** 게임 전체 — 서버의 `PopSeo::games()` 를 옮긴 것이다. */
    games: PopGame[];
}

export interface PopGame {
    slug: string;
    /** 게임 화면 — '/pop/alchemist'. */
    path: string;
    label: string;
    tagline: string;
    summary: string;
    icon: string;
}

export interface PopPoint {
    icon: string;
    title: string;
    desc: string;
}

/**
 * Pop 진입점 반환. **꺼져 있거나 주입되지 않았으면 null** 이다(getInk 와 같은 규칙 — 예외를 던지지 않는다).
 */
export function getPop(): PopEntry | null {
    if (typeof window === 'undefined') {
        return null;
    }

    const pop = (window as unknown as { JadEye?: { pop?: PopEntry | null } }).JadEye?.pop;

    return pop?.landing && Array.isArray(pop?.games) ? pop : null;
}
